import gql from "graphql-tag";

/**
 * Mutation para editar la imagen de perfil
 *
 * Variables:
 * idUsuario: String!
 * imagenPerfil: String!
 * formato: String!
 * idEmpresaFk: String!
 */

export const EDIT_IMAGEN_PERFIL = gql`
  mutation editImagenPerfil(
    $idUsuario: String!
    $imagenPerfil: String!
    $formato: String!
    $idEmpresaFk: String!
  ) {
    editImagenPerfil(
      id_usuario: $idUsuario
      imagen_perfil: $imagenPerfil
      formato: $formato
      id_empresa_fk: $idEmpresaFk
    ) {
      id_usuario
      imagen_perfil
    }
  }
`;

/**
 * Mutation para editar el perfil
 *
 * Variables:
 * idUsuario: String!
 * correo: String!
 * telefonoMovil: String!
 * anexo: String!
 * telefonoFijo: String!
 */
export const EDIT_PERFIL = gql`
  mutation editPerfilUsuario(
    $idUsuario: String!
    $correo: String!
    $telefonoMovil: String!
    $anexo: String!
    $telefonoFijo: String!
  ) {
    editPerfilUsuario(
      id_usuario: $idUsuario
      correo: $correo
      telefono_movil: $telefonoMovil
      anexo: $anexo
      telefono_fijo: $telefonoFijo
    ) {
      id_usuario
      telefono_movil
      anexo
      telefono_fijo
      correo
    }
  }
`;
/**
 * Mutation para editar la contraseña
 *
 * Variables:
 * idUsuario: String!
 * password: String!
 */
export const EDIT_PASSWORD = gql`
  mutation editPasswordUsuarioUpdate($idUsuario: String!, $password: String!) {
    editPasswordUsuarioUpdate(id_usuario: $idUsuario, password: $password) {
      id_usuario
    }
  }
`;
